import { FC } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';

import { AgencyGiftCouponSettlementContainer } from '../containers/AgencyGiftCouponSettlement/AgencyGiftCouponSettlementContainer';

/**
 * 쿠폰형(기프티콘) 답례품 정산 페이지 (상조 전용, 읽기 전용).
 * 사이드바 레이아웃 + 컨테이너 마운트.
 */
export const AgencyAdminGiftSettlementCouponPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1 px-10 py-8">
      <AgencyGiftCouponSettlementContainer />
    </div>
  </div>
);
